const LayoutStore = {
    namespaced: true,
    state: {
        isSideBarOpen: false,

        offline: false,

        updateAvailable: false,
        updatedServiceWorker: null,
    },
    getters: {
        isUpdateAvailable ({ updateAvailable }) {
            return updateAvailable;
        },
        serviceWorker ({ updatedServiceWorker }) {
            return updatedServiceWorker;
        },
        isOnline ({ offline }) {
            return !offline;
        },
    },
    mutations: {
        toggleSideBar (state) {
            state.isSideBarOpen = !state.isSideBarOpen;
        },
        closeSideBar (state) {
            state.isSideBarOpen = false;
        },
        updateAvailable (state, updatedServiceWorker) {
            state.updateAvailable = true;
            state.updatedServiceWorker = updatedServiceWorker;
        },
        online (state) {
            state.offline = false;
        },
        offline (state) {
            state.offline = true;
        }
    },
};

export default LayoutStore;
